export const THERAPIST_GROUP_TTL_ES = 'Grupos Terapéuticos';
export interface ITherapistGroupBase {
  description: string;
}
export interface ITherapistGroup extends ITherapistGroupBase {
  id: number;
}
export type ITherapistGroupUpdate = Partial<ITherapistGroupBase>;
